import { ExperienceContent } from "components";
import { useDocumentTitle } from "hooks";

const Experience = () => {
	useDocumentTitle("Experience | Shreyas Soni");
	return <ExperienceContent />;
};

export { Experience };
